import PropTypes from 'prop-types';
import React, { memo, useCallback } from 'react';
import { Checkbox } from '@bingads-webui-react/primitive-with-signal';
import TextModel from './text-model';
import type { OptionModelProps } from './types';

const OptionModelUnwrapped = ({
  disabled,
  i18n,
  id,
  localizationKey,
  richTextItems,
  isSelected,
  setValue
}: OptionModelProps) => (
  <div className={id}>
    <Checkbox
      name={id}
      onChange={useCallback((val: React.ChangeEvent<HTMLInputElement>) => { setValue(id, val.target.checked); }, [id, setValue])}
      checked={isSelected}
      disabled={disabled}
    >
      <TextModel i18n={i18n} localizationKey={localizationKey} richTextItems={richTextItems} />
    </Checkbox>
  </div>
);
OptionModelUnwrapped.propTypes = {
  disabled: PropTypes.bool.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  id: PropTypes.string.isRequired,
  localizationKey: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  setValue: PropTypes.func.isRequired,
  richTextItems: PropTypes.arrayOf(PropTypes.string).isRequired,
};
OptionModelUnwrapped.displayName = 'OptionModel';
export default memo(OptionModelUnwrapped);
